import { configure } from 'vee-validate';

export default ({ app }) => {
  configure({
    defaultMessage: (field, values) =>
      // eslint-disable-next-line no-underscore-dangle,implicit-arrow-linebreak
      app.i18n.t(`validation.${values._rule_}`, values),
  });
};
